import { ComponentProps, ElementType, PropsWithChildren } from "react";

import { cn } from "@/utils/cn";

interface FullViewProps extends ComponentProps<"div"> {
  as?: ElementType;
}

function FullView({ children, className, as: Component = "div", ...props }: PropsWithChildren<FullViewProps>) {
  return (
    <Component
      className={cn("flex h-[calc(100vh-4rem)] min-h-[calc(100vh-4rem)] flex-col items-center justify-center px-side", className)}
      {...props}
    >
      {children}
    </Component>
  );
}

export default FullView;
